import { useTranslation } from "react-i18next";
import tw from "twin.macro";

const RedText = tw.p`text-2xl font-medium text-red-500`;

export default function OopsSheetBody() {
  const { t: translator } = useTranslation();
  return (
    <div tw="flex flex-col items-center justify-center gap-4">
      <RedText>Oups ...</RedText>
      <p tw="text-lg text-gray-700 text-center">{translator("area.oops")}</p>
    </div>
  );
}
